<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>

  @if (isViewMode && data.notification) {
    <div class="meta-row">
      <span class="meta-item">
        <span class="meta-label">Date:</span> {{ formatDate(data.notification.createdDate) }}
      </span>
      <span class="meta-item">
        <span class="meta-label">Type:</span> {{ data.notification.type }}
      </span>
      <span class="meta-item priority-item" [class]="'priority-' + data.notification.priority.toLowerCase()">
        @if (data.notification.priority === 'High') {
          <span class="priority-exclamation">!</span>
        }
        <span class="meta-label">Priority:</span> {{ data.notification.priority }}
      </span>
    </div>
    <div class="body-content">{{ data.notification.body }}</div>
  } @else {
    <form [formGroup]="form">

      <mat-form-field appearance="outline" class="full-width" [matTooltip]="titleInput.value">
        <mat-label>Title</mat-label>
        <input #titleInput matInput formControlName="title" maxlength="128" />
        @if (form.get('title')?.invalid && (form.get('title')?.dirty || form.get('title')?.touched)) {
          <mat-error>
            @if (form.get('title')?.errors?.['required']) { Title is required. }
            @if (form.get('title')?.errors?.['maxlength']) { Title must be 128 characters or fewer. }
          </mat-error>
        }
      </mat-form-field>

      <div class="row-fields">

        <mat-form-field appearance="outline" class="org-field" [matTooltip]="orgSelect.triggerValue">
          <mat-label>Organization</mat-label>
          <mat-select
            #orgSelect
            formControlName="organizationIds"
            multiple
            panelClass="searchable-panel"
            (ngModelChange)="onOrgSelectionChange($event)"
          >
            <mat-option disabled>
              <ngx-mat-select-search
                [formControl]="orgSearchControl"
                placeholderLabel="Search organizations..."
                noEntriesFoundLabel="No organizations found">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="ALL_ORGS_VALUE">ALL</mat-option>
            @for (org of filteredOrgs$ | async; track org.id) {
              <mat-option [value]="+org.id">{{ org.name }}</mat-option>
            }
          </mat-select>
          @if (form.get('organizationIds')?.invalid && form.get('organizationIds')?.touched) {
            <mat-error>Organization is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="type-field" [matTooltip]="typeSelect.triggerValue">
          <mat-label>Type</mat-label>
          <mat-select #typeSelect formControlName="type">
            @for (t of availableTypes; track t) {
              <mat-option [value]="t">{{ t }}</mat-option>
            }
          </mat-select>
          @if (form.get('type')?.invalid && form.get('type')?.touched) {
            <mat-error>Type is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="priority-field" [matTooltip]="prioritySelect.triggerValue">
          <mat-label>Priority</mat-label>
          <mat-select #prioritySelect formControlName="priority">
            @for (p of priorities; track p) {
              <mat-option [value]="p">{{ p }}</mat-option>
            }
          </mat-select>
          @if (form.get('priority')?.invalid && form.get('priority')?.touched) {
            <mat-error>Priority is required.</mat-error>
          }
        </mat-form-field>

      </div>

      <mat-form-field appearance="outline" class="full-width" [matTooltip]="bodyInput.value">
        <mat-label>Body</mat-label>
        <textarea
          #bodyInput
          matInput
          formControlName="body"
          rows="5"
          maxlength="4000"
        ></textarea>
        @if (form.get('body')?.invalid && (form.get('body')?.dirty || form.get('body')?.touched)) {
          <mat-error>
            @if (form.get('body')?.errors?.['required']) { Body is required. }
            @if (form.get('body')?.errors?.['maxlength']) { Body must be 4000 characters or fewer. }
          </mat-error>
        }
      </mat-form-field>

    </form>
  }

</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!isViewMode) {
    <button
      mat-button
      id="saveButton"
      (click)="onSave()"
      [disabled]="form.invalid || (saving$ | async)"
    >
      Save
    </button>
  }
  <button mat-button (click)="onClose()">Close</button>
</mat-dialog-actions>
